module.exports = __webpack_public_path__ + "media/src/pages/CreateAccount/images/create-account-1c409e5eb29a18aae2604a5366c4a94d.png";